import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ENDPOINTS from "./utils/Endpoints";
import { initAnalytics } from "./utils/Analytics";
import './index.css';


const PreLand1 = lazy(() => import(/* webpackChunkName: PreLand1 */ './components/ios/PreLand1/PreLand1'));
const PreLand2 = lazy(() => import(/* webpackChunkName: PreLand2 */ './components/ios/PreLand2'));
const PreLand3 = lazy(() => import(/* webpackChunkName: PreLand2 */ './components/ios/PreLand3'));
const PreLand4 = lazy(() => import(/* webpackChunkName: PreLand4 */ './components/ios/PreLand4/PreLand4'));
const PreLand5 = lazy(() => import(/* webpackChunkName: PreLand5 */ './components/ios/PreLand5/PreLand5'));
const PreLand6 = lazy(() => import(/* webpackChunkName: PreLand6 */ './components/ios/PreLand6'));
const PreLand7 = lazy(() => import(/* webpackChunkName: PreLand6 */ './components/ios/PreLand7/PreLand7'));


initAnalytics();

const App = () => {
    return (
        <Suspense fallback={<div  />}>
        <BrowserRouter>
            <Routes>
                <Route path={`/${ENDPOINTS.PRE_LAND_IOS1}`} element={ <PreLand1/>} />
                <Route path={`/${ENDPOINTS.PRE_LAND_IOS2}`} element={ <PreLand2/>} />
                <Route path={`/${ENDPOINTS.PRE_LAND_IOS3}`} element={ <PreLand3/>} />
                <Route path={`/${ENDPOINTS.PRE_LAND_IOS4}`} element={ <PreLand4/>} />
                <Route path={`/${ENDPOINTS.PRE_LAND_IOS5}`} element={ <PreLand5/>} />
                <Route path={`/${ENDPOINTS.PRE_LAND_IOS6}`} element={ <PreLand6/>} />
                <Route path={`/${ENDPOINTS.PRE_LAND_IOS7}`} element={ <PreLand7/>} />
            </Routes>
        </BrowserRouter>
        </Suspense>
    );
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

